import { render, staticRenderFns } from "./SelectApprovalTerm.vue?vue&type=template&id=198c03ca"
import script from "./SelectApprovalTerm.vue?vue&type=script&lang=js"
export * from "./SelectApprovalTerm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports